import m from 'mithril'

export default {
  view: vnode => {
    const arc = require('./arc.png')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-27-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>        
        <h3 className="log-book-text mod-h3">Kampen om Grønland - frem til 1962 </h3>

        <h3 className="log-book-text mod-h3">1940: Danmark besat</h3>
        <p className="log-book-text">D. 9. april besætter Nazi-Tyskland Danmark.  </p>

<h3 className="log-book-text mod-h3">1941: USA forsvarer Grønland</h3>
<p className="log-book-text">USA overtager forsvaret af Grønland. Den første ‘Grønlandsoverenskomst’ indgås af den selvudråbte repræsentant for den danske regering i Washington, diplomat Henrik Kaufmann. Grønland er vigtig for USA som forsyningsrute til det allierede Storbritannien, og som mellemlandingsstation for det amerikanske flyvevåben. Det besatte Danmark fyrer Kaufmann og anklager ham for landsforræderi, men USA anerkender Kauffmann, som den legitime repræsentant for Danmark, da den danske regering er under tysk kontrol.   
Aftalen giver bl.a. USA ret til at “anlægge, opretholde og operere” fly- og flådebaser i Grønland. Danmark bevarer dog suveræniteten over Grønland.</p>

<h3 className="log-book-text mod-h3">1945: Folketinget godkender baser</h3> 
<p className="log-book-text">Efter Danmarks befrielse godkender Folketinget enstemmigt Henrik Kaufmanns overenskomst med USA.</p>  

<h3 className="log-book-text mod-h3">1946: USA vil købe Grønland </h3>
<p className="log-book-text">USA forsøger at købe Grønland af Danmark for 100 millioner dollar. Grønland spiller en afgørende rolle i USA’s nye polarstrategi og i Vestens militære og politiske konfrontation med  
Sovjetunionen. Danmark afviser at sælge. Grønland er et vigtigt ‘kort’ at have på hånden, og Danmark er også under pres fra Sovjetunionen, der vil opfatte salget som en fjendtlig handling.</p>

<h3 className="log-book-text mod-h3">1951: Operation Blue Jay</h3>
<p className="log-book-text">Ny Grønlandsoverenskomst mellem Danmark og USA. I aftalen fastholder Danmark suveræniteten over Grønland, men USA får lov til at øge sin tilstedeværelse og får mere bevægelsesfrihed. Amerikanerne iværksætter ‘Operation Blue Jay’, fragter 120 skibe og  12.000 mand til Thule og påbegynder etableringen af Thulebasen. </p>

<h3 className="log-book-text mod-h3">1953: Grønland ligestillet</h3>
<p className="log-book-text">Grønlands status som koloni ophører. Landet er nu formelt en ligestillet del af Danmark, og grønlænderne får dansk statsborgerskab. Få uger forinden flyttes Thuleboerne fra området nær den amerikanske base. </p>

<h3 className="log-book-text mod-h3">1953: Ingen atomvåben ...</h3>
<p className="log-book-text">Danmark siger officielt nej til atomvåben på dansk jord. </p>

<h3 className="log-book-text mod-h3">1957: ...eller?</h3>
<p className="log-book-text">USA spørger, om Danmark vil underrettes, hvis man placerer atomvåben i Grønland. Find statsminister H.C.Hansens svar i reaktorrummet. </p>

<h3 className="log-book-text mod-h3">1959: Camp Century. </h3>
<p className="log-book-text">USA spørger Danmark om lov til at opføre Camp Century. Basen er kontroversiel, og Danmark tøver med at svare. Amerikanerne har hemmelige planer, som vil gøre Camp Century til et afgørende våben i den storpolitiske konflikt med Sovjetunionen. </p>

        </div>
      </div>
    )
  }
}
